export function closeInMilliseconds(ms: number) {
  setTimeout(() => close(), ms);
}
